"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('services/vehicleManagementService',["require", "exports", "controllers/vehicleManagementController", "routing/mainRouter"], function (require, exports, vehicleManagementController, mainRouter) {
    "use strict";

    var VehicleManagementDataService = function () {
        function VehicleManagementDataService() {
            _classCallCheck(this, VehicleManagementDataService);
        }

        _createClass(VehicleManagementDataService, [{
            key: "getOperationsCounts",
            value: function getOperationsCounts() {
                return vehicleManagementController.getOperationsCounts();
            }
        }, {
            key: "getVehicleManagementOperations",
            value: function getVehicleManagementOperations() {
                return vehicleManagementController.getVehicleManagementOperations();
            }
        }, {
            key: "getExistingManufacturers",
            value: function getExistingManufacturers() {
                return vehicleManagementController.getExistingManufacturers();
            }
        }, {
            key: "addNewManufacturer",
            value: function addNewManufacturer(dbName, newName) {
                return vehicleManagementController.addNewManufacturer({ dbName: dbName, newName: newName });
            }
        }, {
            key: "associateWithManufacturer",
            value: function associateWithManufacturer(dbName, associatedManufacturer) {
                return vehicleManagementController.associateWithManufacturer({ dbName: dbName, associateToManufacturer: associatedManufacturer });
            }
        }, {
            key: "loadVariantGroupForManufacturer",
            value: function loadVariantGroupForManufacturer(manufacturerName) {
                return vehicleManagementController.loadVariantGroupForManufacturer({ manufacturerName: manufacturerName });
            }
        }, {
            key: "addNewVariantGroup",
            value: function addNewVariantGroup(modelVariants, newVariantGroupName) {
                return vehicleManagementController.addNewVariantGroup({ modelVariants: modelVariants, newVariantGroupName: newVariantGroupName });
            }
        }, {
            key: "addVariantToExistingVariantGroup",
            value: function addVariantToExistingVariantGroup(modelVariants, variantGroup) {
                return vehicleManagementController.addVariantToExistingVariantGroup({ modelVariants: modelVariants, variantGroupName: variantGroup.variantGroupName });
            }
        }, {
            key: "getGroupVariantsForModel",
            value: function getGroupVariantsForModel(manufacturerName, groupName) {
                return vehicleManagementController.getGroupVariantsForModel({ manufacturerName: manufacturerName, variantGroupName: groupName });
            }
        }, {
            key: "getGenerationsForGroup",
            value: function getGenerationsForGroup(manufacturerName, groupName) {
                return vehicleManagementController.getGenerationsForGroup({ manufacturerName: manufacturerName, variantGroupName: groupName });
            }
        }, {
            key: "saveModelGeneration",
            value: function saveModelGeneration(request) {
                return vehicleManagementController.saveModelGeneration(request);
            }
        }, {
            key: "uploadManufacturerImage",
            value: function uploadManufacturerImage(imageFile, manufacturerName) {
                return vehicleManagementController.uploadManufacturerImage(imageFile, manufacturerName);
            }
        }, {
            key: "getPolicyVehicleStats",
            value: function getPolicyVehicleStats() {
                return vehicleManagementController.getPolicyVehicleStats();
            }
        }, {
            key: "uploadModelImage",
            value: function uploadModelImage(imageFile, manufacturerName, variantGroupName) {
                return vehicleManagementController.uploadModelImage(imageFile, manufacturerName, variantGroupName);
            }
        }, {
            key: "uploadModelgenerationImage",
            value: function uploadModelgenerationImage(imageFile, manufacturerName, variantGroupName, generation) {
                return vehicleManagementController.uploadModelgenerationImage(imageFile, manufacturerName, variantGroupName, generation);
            }
        }, {
            key: "saveEditedGeneration",
            value: function saveEditedGeneration(request) {
                return vehicleManagementController.saveEditedGeneration(request);
            }
        }, {
            key: "deleteModelGeneration",
            value: function deleteModelGeneration(request) {
                return vehicleManagementController.deleteModelGeneration(request);
            }
        }, {
            key: "getEnvironment",
            value: function getEnvironment() {
                return mainRouter.router.environmentId();
            }
        }]);

        return VehicleManagementDataService;
    }();

    var vehicleManagementDataService;
    vehicleManagementDataService = new VehicleManagementDataService();
    return vehicleManagementDataService;
});
//# sourceMappingURL=vehicleManagementService.js.map;
